import { required, dataMember, typedArray } from 'santee-dcts';
import { deserializers } from '../../core';
import * as moment from 'moment';

export class KitDetail {
    @dataMember()
    @required({ nullable: true })
    public accessionNumber: string;

    @dataMember({ customDeserializer: value => moment(value) })
    @required({ nullable: true })
    public expiresOn: moment.Moment;

    public getExpiredDateFormat(): string {
        return this.expiresOn.format('MM/DD/YYYY');
    }
}

export class KitDetailReadModel {
    @dataMember()
    @required()
    @typedArray(KitDetail)
    public kitDetails: KitDetail[];
}
